/** Returns a copy of `list` with the item at `from` moved by `delta` places. */
export function moveListItem<T>(
  list: readonly T[],
  from: number,
  delta: number,
): T[] {
  const to = from + delta;
  if (from < 0 || from >= list.length || to < 0 || to >= list.length) {
    return [...list];
  }
  const next = [...list];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item as T);
  return next;
}
